module.exports = __webpack_public_path__ + "img/ew-icon_community.09f5b9b7.svg";